export interface IPromoCodeState {
    /**
     * Set to true if the app is waiting for a response from the promo-code API.
     */
    promoCodeRequesting: boolean;
    /**
     * The promo code that is currently being entered.
     */
    promoCodeString: string;
    /**
     * The promo code that has been applied.
     */
    appliedPromoCode: string;
    /**
     * The response from the last time the promo code API was called.
     */
    promoApiResponse: any;
    /**
     * The current state of the promo code.
     */
    promoCodeState: PromoCodeState;
    /**
     * If the API responds with an error.
     */
    promoCodeError: any;

    showPromo: boolean;
    showPromoResult: boolean;
}


export enum PromoCodeState {
    APPLIED,
    FAILURE,
    ATTEMPT
}

export interface IPromoCodeDetail {
    promoCode: string;
    text1: string;
    text2: string;
    text3: string;
    text4: string;
    text5: string;
    text6: string;
}

export const defaultPromoCodeDetail: IPromoCodeDetail ={
    promoCode: "",
    text1: "",
    text2: "",
    text3: "",
    text4: "",
    text5: "",
    text6: "",
}

export const defaultPromoCodeState: IPromoCodeState = {
    appliedPromoCode: "",
    promoCodeRequesting: false,
    promoCodeState: PromoCodeState.ATTEMPT,
    promoApiResponse: null,
    promoCodeError: null,
    promoCodeString: "",
    showPromo: false,
    showPromoResult: false
};